import type { RuleHandler } from "../types";
import { setIncludes } from "utilities/promotions/setIncludes";

const checkExcludedMeetingIds: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  return !setIncludes(
    new Set(requirementAttributes?.excludedMeetingIds),
    new Set(context.selection.meetingIds),
  );
};

export { checkExcludedMeetingIds };
